import { PERSISTENT_TOASTR_SETTINGS, SOCKET_CHANNELS } from '@/config';
import echoInstance from '@/services/broadcasting/echo';
import { error } from 'toastr';

export const Webupload = {
  namespaced: true,

  state: {
    progressbyUploadKey: {},
    socketDataByUploadKey: {},
  },

  getters: {
    getUploadProgress:
      ({ progressbyUploadKey }) =>
      (uploadKey) =>
        progressbyUploadKey[uploadKey],
    getSocketData:
      ({ socketDataByUploadKey }) =>
      (uploadKey) =>
        socketDataByUploadKey[uploadKey],
  },

  mutations: {
    setProgressbyUploadKey(state, payload) {
      Vue.set(state.progressbyUploadKey, Object.keys(payload)[0], Object.values(payload)[0]);
    },
    setSocketDataByUploadKey(state, payload) {
      Vue.set(state.socketDataByUploadKey, Object.keys(payload)[0], Object.values(payload)[0]);
    },
  },

  actions: {
    subscribeToWebupload({ commit }, { uploadKey, vm }) {
      const channelName = SOCKET_CHANNELS.webupload.replace('{uploadKey}', uploadKey);
      const leaveCallback = () => echoInstance.leave(channelName);

      echoInstance
        .channel(channelName)
        // .listenToAll(() => {})
        // .listen('.webupload.started', () => {})
        .listen('.webupload.progress', ({ import: { progress } }) => {
          commit('setProgressbyUploadKey', { [uploadKey]: progress });
        })
        .listen('.webupload.progress', (data) => {
          commit('setSocketDataByUploadKey', { [uploadKey]: data.import });
        })
        .listen('.webupload.success', () => {
          leaveCallback();
        })
        .listen('.webupload.failure', (err) => {
          const string = vm.$te(`cmrad.web_uploader_dicom_error_${err.reason}`)
            ? vm.$t(`cmrad.web_uploader_dicom_error_${err.reason}`)
            : vm.$t(`cmrad.${err.reason}`) ?? vm.$t('cmrad.web_uploader_dicom_upload_failed_fallback');

          console.log({ err });

          error(string, null, PERSISTENT_TOASTR_SETTINGS);
          leaveCallback();
        });
    },
  },
};
